import type { ReactElement } from 'react';
import { DomainV2 } from 'troppus-common/domain';

import { resultBadgeClass, resultLabel, statusBadgeClass, statusLabel } from './detail/formatters';

import ImportTask = DomainV2.Import.ImportTask;

type TaskResultBadgeProps = {
  task: Pick<ImportTask, 'status' | 'resultType'>;
};

/** 詳細ページの「結果」と同じく、未完了時はステータス＋実行中はスピナー、完了後は結果種別を表示する */
export function TaskResultBadge({ task }: TaskResultBadgeProps): ReactElement {
  const isIncomplete = task.status === 'Requested' || task.status === 'Started';
  const badgeClass = isIncomplete ? statusBadgeClass(task.status) : resultBadgeClass(task.resultType);
  const label = isIncomplete ? statusLabel(task.status) : resultLabel(task.resultType);

  return (
    <span className={`inline-flex items-center gap-1.5 rounded px-2.5 py-1 text-xs font-medium ${badgeClass}`}>
      {task.status === 'Started' ? (
        <span className="size-2.5 animate-spin rounded-full border border-current border-t-transparent" aria-hidden="true" />
      ) : null}
      {label}
    </span>
  );
}
